module.exports = __webpack_public_path__ + "img/lights.9e08e176.png";